import { render, staticRenderFns } from "./StateProgramReferralText.vue?vue&type=template&id=a7996372&scoped=true&"
import script from "./StateProgramReferralText.vue?vue&type=script&lang=js&"
export * from "./StateProgramReferralText.vue?vue&type=script&lang=js&"
import style0 from "./StateProgramReferralText.vue?vue&type=style&index=0&id=a7996372&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7996372",
  null
  
)

export default component.exports